import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';

import RecipientList from './components/RecipientList';

app.initializers.add('happydigital-byobu-recipients', () => {
  // fof/byobu exposes its modals on its module exports. composer.json requires
  // byobu, so Flarum loads its bundle before this one.
  const byobu = flarum.extensions['fof-byobu'];
  const AddRecipientModal = byobu && byobu.modals && byobu.modals.AddRecipientModal;

  if (!AddRecipientModal) return;

  // Insert the list right after the modal's help text, ahead of the search
  // field. Byobu's own click-to-remove labels are hidden in forum.less rather
  // than removed here, because they live inside RecipientSearch, which byobu
  // does not export.
  extend(AddRecipientModal.prototype, 'content', function (content) {
    const body = (Array.isArray(content) ? content : [content]).find((vnode) => hasClass(vnode, 'Modal-body'));

    if (!body || !Array.isArray(body.children)) return;

    body.children.splice(
      1,
      0,
      RecipientList.component({
        selected: this.selected,
        discussion: this.attrs.discussion,
      })
    );
  });
});

function hasClass(vnode, className) {
  if (!vnode || !vnode.attrs) return false;

  const classes = String(vnode.attrs.className || vnode.attrs.class || '').split(/\s+/);

  return classes.indexOf(className) !== -1;
}
